export const EventDispatcher = {
    _listeners: {},
    on(event, callback) {
        if (!this._listeners[event]) {
            this._listeners[event] = new Set();
        }

        if (!this._listeners[event].has(callback)) {
            this._listeners[event].add(callback);
            document.addEventListener(event, callback);

            // // Stacktrace loggen
            // const stack = new Error().stack.split('\n').slice(2, 5).join('\n');

            // console.log(`Listener added for: ${event} (total: ${this._listeners[event].size})`);
            // console.log('Added from:\n' + stack);
        }
    },
    off(event, callback) {
        document.removeEventListener(event, callback);
    },
    emit(event, detail = {}) {
        document.dispatchEvent(new CustomEvent(event, { detail }));
    },
    onWindow(event, callback) {
        window.addEventListener(event, callback);
    },
};
